module.exports = __webpack_public_path__ + "img/Screen_3.a299d43d.png";